// @fileoverview : 경남-PMS > 고속성형기관리 > 설비수리요청
import { useModal } from "@/features/modal/ModalStackManager";
import customAlert from "@/features/ui/alert/Alert";
import { Calendar } from "@/features/ui/calendar";
import { GridTable } from "@/features/ui/PMS/gridTable";
import { MachineSearchBox } from "@/features/ui/PMS/machineSearchBox";
import { Button, Flex, Input, Select, Text } from "@mantine/core";
import { IconCalendar, IconSearch } from "@tabler/icons-react";
import { useState } from "react";
import { Column, SelectColumn } from "react-data-grid";

export const PressFacilitiesPage = () => {
  const { openModal } = useModal();

  const columns: readonly Column<any>[] = [
    { key: "manufacturer", name: "기계 제조사", sortable: true, resizable: true },
    { key: "machineName", name: "기계 이름", sortable: true, resizable: true },
    {
      key: "errorType",
      name: "문제유형(필수)",
      sortable: true,
      resizable: true,
    },
    { key: "machineType", name: "기계 종류", sortable: true, resizable: true },
    { key: "weldType", name: "용접 종류", sortable: true, resizable: true },
    { key: "manufactureDate", name: "제조 연원일", sortable: true, resizable: true },
    { key: "serialNumber", name: "제조 번호", sortable: true, resizable: true },
    { key: "manager", name: "담당자", sortable: true, resizable: true },
    { key: "machinePhoto", name: "기계 사진", sortable: true, resizable: true },
    { key: "specPlatePhoto", name: "스펙 명판 사진", sortable: true, resizable: true },
    { key: "capacityPlatePhoto", name: "능력 명판 사진", sortable: true, resizable: true },
    { key: "manual", name: "사용 설명서", sortable: true, resizable: true },
    { key: "overhaul", name: "오버홀", sortable: true, resizable: true },
    { key: "peripherals", name: "주변 장치", sortable: true, resizable: true },
    { key: "tonnage", name: "톤 수", sortable: true, resizable: true },
    { key: "voltage", name: "사용 전압", sortable: true, resizable: true },
    { key: "factory", name: "공장명", sortable: true, resizable: true },
    { key: "factoryDetail", name: "공장 세분화명", sortable: true, resizable: true },
    { key: "product", name: "생산 품목", sortable: true, resizable: true },
    { key: "priority", name: "우선순위", sortable: true, resizable: true },
    { key: "requestDate", name: "요청 날짜", sortable: true, resizable: true },
    { key: "requestPhoto", name: "요청 사진", sortable: true, resizable: true },
    { key: "requester", name: "요청자", sortable: true, resizable: true },
    { key: "dueDate", name: "완료 요청 날짜", sortable: true, resizable: true },
  ];

  const [rows, setRows] = useState<any>([]);
  const { closeModal } = useModal();

  return (
    <Flex gap="md" direction="column">
      <Flex justify={"space-between"}>
        <Text size="xl">설비 수리 요청</Text>
        <Flex gap="sm">
          <Button
            onClick={() => {
              openModal(
                <MachineSearchBox
                  onSelect={(data) => {
                    const newRow = {
                      manufacturer: data?.make || "한진기계",
                      machineName: data?.name || "Line Cutter",
                      errorType: "점검",
                      machineType: "절단기",
                      weldType: "TIG",
                      manufactureDate: "2020-11-02",
                      serialNumber: "HJ-2020-456",
                      manager: "이영희",
                      machinePhoto: "linecutter.jpg",
                      specPlatePhoto: "linecutter_spec.jpg",
                      capacityPlatePhoto: "linecutter_capacity.jpg",
                      manual: "linecutter_manual.pdf",
                      overhaul: "2025-01-10",
                      peripherals: "집진기",
                      tonnage: "150T",
                      voltage: "220V",
                      factory: "부산제조소",
                      factoryDetail: "2-A라인",
                      product: "알루미늄 커버",
                      priority: "중",
                      requestDate: "2025-06-25",
                      requestPhoto: "issue_line.jpg",
                      requester: "박민수",
                      dueDate: "2025-07-05",
                    };

                    setRows((prevRows: any) => [...prevRows, newRow]);
                    closeModal({});
                  }}
                />,
                null,
                "기계 검색",
              );
            }}
          >
            추가하기
          </Button>
          <Button
            onClick={() => {
              customAlert("설비수리 요청이 등록 되었습니다.", "저장", "취소");
            }}
          >
            저장하기
          </Button>
          <Button color="red">삭제</Button>
        </Flex>
      </Flex>

      <Flex justify={"flex-end"} gap="sm">
        <Button
          leftIcon={<IconCalendar />}
          color="indigo"
          onClick={() => {
            openModal(<Calendar dates={[null, null]} type="range" />, null, "날짜 선택");
          }}
        >
          날짜선택
        </Button>
        <Select
          w={"8rem"}
          data={[
            { label: "기계 제조사", value: "manufacturer" },
            { label: "기계명", value: "machineName" },
            { label: "제조번호", value: "serialNumber" },
            { label: "담당자", value: "manager" },
            { label: "문제점", value: "errorType" },
          ]}
        />
        <Input w={"16rem"} placeholder="검색어를 입력하세요" rightSection={<IconSearch />} />
        <Button>검색</Button>
      </Flex>

      <GridTable headerList={[SelectColumn, ...columns]} row={rows} setRow={setRows} />
    </Flex>
  );
};
